/**
 * Inject "Not Applicable" entries for cross-framework assessment filtering.
 *
 * When a project has cross-framework alignment, safeguards not mapped to the
 * selected external standards should be treated as NA so they are excluded
 * from the scoring denominator and hidden from tables/charts.
 *
 * Mutates processedItems in place (pushes synthetic NA entries, overrides
 * existing answers for out-of-scope safeguards).
 *
 * @param {Array} processedItems - Processed project items (mutated in place)
 * @param {Object} qualityItems - Quality items organized by category/topic
 * @param {string} year - Assessment year (e.g. "2024", "2025", "2026")
 * @returns {Promise<void>}
 */
(function($) {
	async function injectCrossFrameworkNA(processedItems, qualityItems, year) {
		var cd = window.controlsData;
		if (!cd) return;

		var xfwRaw = cd.cross_framework_alignment || '';
		if (!xfwRaw || typeof xfwRaw !== 'string' || xfwRaw.length <= 2) return;

		var xfwStandards;
		try {
			xfwStandards = JSON.parse(xfwRaw);
		} catch (e) {
			return;
		}
		if (!Array.isArray(xfwStandards) || xfwStandards.length === 0) return;

		var response;
		try {
			response = await $.ajax({
				url: cd.ajax_url,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'get_cross_framework_safeguard_ids',
					year: year,
					standardids: xfwStandards
				}
			});
		} catch (err) {
			console.error('[injectCrossFrameworkNA] AJAX failed, skipping cross-framework NA injection:', err);
			return;
		}

		if (!response || !response.success || !Array.isArray(response.data)) return;

		var allowedIds = new Set(response.data);
		console.log('[injectCrossFrameworkNA] Cross-framework active: ' + allowedIds.size + ' allowed safeguard IDs for year ' + year);

		var processedLookup = {};
		processedItems.forEach(function(item) {
			processedLookup[item.safeguardid.S] = item;
		});

		var injectedCount = 0;
		var overriddenCount = 0;

		Object.keys(qualityItems).forEach(function(category) {
			Object.keys(qualityItems[category]).forEach(function(topic) {
				qualityItems[category][topic].forEach(function(qItem) {
					var sgId = qItem.safeguardid.S;
					if (allowedIds.has(sgId)) return;

					var existing = processedLookup[sgId];
					if (existing) {
						existing.policystatus = { N: "1" };
						existing.maturityscore = null;
						overriddenCount++;
					} else {
						var syntheticItem = {
							safeguardid: { S: sgId },
							policystatus: { N: "1" },
							maturityscore: null,
							timestamp: { S: "0" }
						};
						processedItems.push(syntheticItem);
						processedLookup[sgId] = syntheticItem;
						injectedCount++;
					}
				});
			});
		});

		console.log('[injectCrossFrameworkNA] Injected ' + injectedCount + ' NA entries, overrode ' + overriddenCount + ' existing answers');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = injectCrossFrameworkNA;
	} else if (typeof window !== 'undefined') {
		window.injectCrossFrameworkNA = injectCrossFrameworkNA;
	}
})(jQuery);
